import { render, staticRenderFns } from "./HolidayShow.vue?vue&type=template&id=a3568248"
import script from "./HolidayShow.vue?vue&type=script&lang=ts"
export * from "./HolidayShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports